import { createAppAsyncThunk } from 'src/store/utils/thunks';
import { wsMmSend, createMmWsAction } from '@skynet/data-ws-mm';

import { LoanCommands } from '@skynet/loans';

export interface HideLoanPayload {
  loanID?: number;
}

export const hideLoan = createAppAsyncThunk('loans/hideLoan', (data: HideLoanPayload, thunkApi) => {
  thunkApi.dispatch(
    wsMmSend({
      command: LoanCommands.HideLoan,
      ...data,
    }),
  );
});

export interface ListenPayload {
  section: string; // either `"overview"` or `exchange.name`
  loanID?: number;
  ticker?: string;
  timeframe?: string;
}

export const listen = createMmWsAction<ListenPayload, ListenPayload>('loans/listen', (data) => ({
  command: 'Listen',
  ...data,
}));
